import React from "react";
import { RequestFeedback } from "@/types/requestFeedback";
import RatingStars from "./RatingStars";
import { DateCell } from "@/components/pages/settlement/components/table-cells/DateCell";
import { MainGuestCell } from "@/components/pages/settlement/components/table-cells/MainGuestCell";

type Props = { feedback: RequestFeedback };

export const FeedbackItem: React.FC<Props> = ({ feedback }) => {
  const date = feedback.createdAt ? new Date(feedback.createdAt) : null;

  const feedbackAuthor = feedback.guest;
  return (
    <div className="flex flex-row justify-between items-center gap-2">
      <DateCell date={date} className={"flex flex-row justify-self-start"} />
      {feedbackAuthor && (
        <MainGuestCell
          id={feedbackAuthor.id}
          firstName={feedbackAuthor.profile?.firstName}
          lastName={feedbackAuthor.profile?.lastName}
          nationality={feedbackAuthor.profile?.language}
        />
      )}
      <RatingStars value={feedback.rating ?? 0} readOnly />
      <span>{feedback.content}</span>
    </div>
  );
};

export default FeedbackItem;
